/**
 * Home Bestsellers – tab switching + swatch variant selection.
 */

class HomeBestsellers extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('.section-home-bestsellers__tab');
    this.panels = this.querySelectorAll('[data-tab]');
    this.scrollContainer = this.querySelector('.section-home-bestsellers__scroll');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.switchTab(tab.dataset.tabIndex);
      });
    });

    /* Swatch click handlers */
    this.querySelectorAll('.section-home-bestsellers__swatch[data-variant-id]').forEach((swatch) => {
      swatch.addEventListener('click', () => this.onSwatchClick(swatch));
    });
  }

  switchTab(index) {
    this.tabs.forEach((tab) => {
      tab.classList.toggle(
        'section-home-bestsellers__tab--active',
        tab.dataset.tabIndex === index
      );
    });

    this.panels.forEach((el) => {
      el.classList.toggle('is-visible', el.dataset.tab === index);
    });

    if (this.scrollContainer) {
      this.scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }

  onSwatchClick(swatch) {
    const card = swatch.closest('.section-home-bestsellers__card');
    if (!card) return;

    const variantId = swatch.dataset.variantId;
    const isAvailable = swatch.dataset.available === 'true';
    const imageUrl = swatch.dataset.image;
    const imageSrcset = swatch.dataset.imageSrcset;
    const price = swatch.dataset.price;
    const comparePrice = swatch.dataset.comparePrice;

    /* Update swatch selection */
    card.querySelectorAll('.section-home-bestsellers__swatch').forEach((s) => {
      s.classList.remove('section-home-bestsellers__swatch--selected');
    });
    swatch.classList.add('section-home-bestsellers__swatch--selected');

    /* Update variant ID in the form (direct add-to-cart mode) */
    const variantInput = card.querySelector('input.product-variant-id');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = !isAvailable;
    }

    /* Update the submit button state */
    const submitBtn = card.querySelector('.section-home-bestsellers__add-to-cart-btn[type="submit"]');
    if (submitBtn) {
      const addText = submitBtn.dataset.addToCartText;
      const soldOutText = submitBtn.dataset.soldOutText;
      const labelSpan = submitBtn.querySelector('span:not(.sold-out-message):not(.loading__spinner)');

      if (isAvailable) {
        submitBtn.removeAttribute('disabled');
        if (labelSpan && addText) labelSpan.textContent = addText;
      } else {
        submitBtn.setAttribute('disabled', 'disabled');
        if (labelSpan && soldOutText) labelSpan.textContent = soldOutText;
      }
    }

    /* Update card image */
    if (imageUrl) {
      const img = card.querySelector('.section-home-bestsellers__card-img');
      if (img) {
        img.src = imageUrl;
        if (imageSrcset) img.srcset = imageSrcset;
      }
    }

    /* Update price display */
    if (price) {
      const priceEl = card.querySelector('.section-home-bestsellers__card-price');
      if (priceEl) priceEl.textContent = price;
    }

    const comparePriceEl = card.querySelector('.section-home-bestsellers__card-compare-price');
    if (comparePrice) {
      if (comparePriceEl) {
        comparePriceEl.textContent = comparePrice;
        comparePriceEl.style.display = '';
      } else {
        /* Create compare price element if it doesn't exist */
        const pricesWrap = card.querySelector('.section-home-bestsellers__card-prices');
        if (pricesWrap) {
          const s = document.createElement('s');
          s.className = 'section-home-bestsellers__card-compare-price';
          s.textContent = comparePrice;
          pricesWrap.appendChild(s);
        }
      }
    } else if (comparePriceEl) {
      comparePriceEl.style.display = 'none';
    }
  }
}

if (!customElements.get('home-bestsellers')) {
  customElements.define('home-bestsellers', HomeBestsellers);
}
